import { File, FlagTriangleRight, type LucideIcon, Text, TextSearch } from 'lucide-react';

import { type AddContextMenuKind } from '../types';

/** One icon per kind, so a kind looks the same on its menu row and on its chips. */
export const CONTEXT_KIND_ICONS: Record<AddContextMenuKind, LucideIcon> = {
  document: File,
  finding: TextSearch,
  milestone: FlagTriangleRight,
  'response-requirement': Text,
};
